const videoContainers = document.querySelectorAll('.video-container');
if (videoContainers.length > 0) {
    videoContainers.forEach(c => {
        const playButton = c.querySelector('.play-button');
        const video = c.querySelector("video");

        // Play or pause the video and toggle the button visibility
        playButton.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                playButton.classList.add('hidden'); // Hide the play button when playing
            }
        });

        // Pause or play the video when clicking on the video itself
        video.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                playButton.classList.add('hidden');
            } else {
                video.pause();
                playButton.classList.remove('hidden');
            }
        });

        // Show the play button when the video ends
        video.addEventListener('ended', () => {
            playButton.classList.remove('hidden');
        });
    })
}


// WEBPACK FOOTER //
// ./client/src/site__scf001/components/wysiwyg/video-block.js